import { Model } from '@vuex-orm/core'
import shortid from 'shortid'
import moment from "moment/moment"
import store from '../store';
import RequestOrderProduct from './RequestOrderProduct';

export default class Product extends Model {
    static entity = 'products'
    static fields() {
        return {
            id: this.attr('tmp/' + shortid.generate()),
            zepplinId: this.attr(null),
            name: this.attr(null),
            companyId: this.attr(null),
            price: this.attr(0),
            quantity: this.attr(1),
            isDefault: this.attr(0),
            dateUpdated: this.attr(moment()),
            dateCreated: this.attr(moment()),
            dateRemoved: this.attr(null),
            zepplinCompanyBrandProduct: this.attr({
                brandProductId: null,
                unitPrice: 0,
                unitDiscount: 0,
                deliveryTax: 0
            }),
            status: this.attr('active'),
            productRequestOrderProducts: this.hasMany(RequestOrderProduct, 'productId')
        }
    }

    static beforeCreate(model) {
        if(!model.companyId) model.companyId = store.state.auth.user.defaultCompanyId
    }

    static deleteById(productId) {
        const product = Product.query().where('id', productId).first()
        if(product.productRequestOrderProducts && product.productRequestOrderProducts.length !== 0) return
        product.$delete()
    }
}